export { SEEK_SIGNAL, PAUSE_SIGNAL } from '../progressBar/progressBar.constants';

export const TOP_BAR_ITEM_SELECTED_SIGNAL = 'topBarItemSelected';

export const SIDE_GLASS_ITEM_SELECTED_SIGNAL = 'sideGlassItemSelected';

export const PLAYING_STATE = 'Playing';

export const PAUSED_STATE = 'Paused';

export const CONTROLS_SHOW_SIGNAL = 'onControlsShow';

export const CONTROLS_HIDE_SIGNAL = 'onControlsHide';
